import Button from './components/Button/Button'
import Card from './components/Card/Card'
import CardHeader from './components/Card/Header'
import Divider from './components/Divider/Divider'
import Footer from './components/Footer/Footer'

/* FORM */
import Autocomplete from './components/Form/Autocomplete'
import Checkbox from './components/Form/Checkbox'
import CheckboxMini from './components/Form/CheckboxMini'
import Radio from './components/Form/Radio'
import RadioGroup from './components/Form/RadioGroup'
import FormDropdown from './components/Form/Dropdown'
import Input from './components/Form/Input'
import Rate from './components/Form/Rate'
import RateActive from './components/Form/RateActive'
import Textarea from './components/Form/Textarea'
import TextareaAutosize from './components/Form/TextareaAutosize'
import ToggleInput from './components/Form/ToggleInput'
import Datepicker from './components/Form/Datepicker'
import VerticalButton from './components/Form/VerticalButton'
/* FORM - END */

/* ICON */
import Icon from './components/Icon/Icon'
import GraphIcon from './components/Icon/GraphIcon'
import Iconify from '../src/components/Icon/Iconify.vue'
import Old5emo from '../src/components/Icon/Old5emo.vue'
/* ICON - END */

/* MENU */
import Menu from './components/Menu/Menu'
import MenuDropdown from './components/Menu/Dropdown'
import Local from './components/Menu/Local'
import MobileButton from './components/Menu/MobileButton'
import Search from './components/Menu/Search'
import Secondary from './components/Menu/Secondary'
/* MENU - END */

import Paginate from './components/Paginate/Paginate'
import Tooltip from './components/Tooltip/Tooltip'

/* TYPOGRAPHY */
import Heading from './components/Typography/Heading'
import Paragraph from './components/Typography/Paragraph'
import TextStyle from './components/Typography/TextStyle'
/* TYPOGRAPHY - END */

import Alert from './components/Alert/Alert'
import Modal from './components/Modal/Modal'

/* Tables */
import Table from './components/Table/Table'

// Single Page
import SingleEnumSingle from './components/SinglePage/SingleEnumSingle'
import SingleEnumMultiple from './components/SinglePage/SingleEnumMultiple'
import SingleMatrix10num from './components/SinglePage/SingleMatrix10num'
import SingleMatrix5num from './components/SinglePage/SingleMatrix5num'
import Single5emo from './components/SinglePage/Single5emo'
import SingleRate from './components/SinglePage/SingleRate'
import Single7button from './components/SinglePage/Single7button'
import SingleYn from './components/SinglePage/SingleYn'
import SingleYnm from './components/SinglePage/SingleYnm'
import SingleYnd from './components/SinglePage/SingleYnd'
import SingleNvs from './components/SinglePage/SingleNvs'
import Accordion from './components/Accordion/Accordion.vue'

export default {
  install (Vue) {
    Vue.component('AppSingleEnumSingle', SingleEnumSingle)
    Vue.component('AppSingleEnumMultiple', SingleEnumMultiple)
    Vue.component('AppSingleMatrix10num', SingleMatrix10num)
    Vue.component('AppSingleMatrix5num', SingleMatrix5num)
    Vue.component('AppSingleYn', SingleYn)
    Vue.component('AppSingleYnm', SingleYnm)
    Vue.component('AppSingleYnd', SingleYnd)
    Vue.component('AppSingleNvs', SingleNvs)
    Vue.component('AppSingle5emo', Single5emo)
    Vue.component('AppSingle7button', Single7button)
    Vue.component('AppSingleRate', SingleRate)
    Vue.component('AppButton', Button)
    Vue.component('AppCard', Card)
    Vue.component('AppCardHeader', CardHeader)
    Vue.component('AppDivider', Divider)
    Vue.component('AppFooter', Footer)
    Vue.component('AppFormAutocomplete', Autocomplete)
    Vue.component('AppFormCheckbox', Checkbox)
    Vue.component('AppFormCheckboxMini', CheckboxMini)
    Vue.component('AppFormRadio', Radio)
    Vue.component('AppFormRadioGroup', RadioGroup)
    Vue.component('AppFormDropdown', FormDropdown)
    Vue.component('AppFormInput', Input)
    Vue.component('AppFormVerticalButton', VerticalButton)
    Vue.component('AppFormRate', Rate)
    Vue.component('AppFormRateActive', RateActive)
    Vue.component('AppFormTextarea', Textarea)
    Vue.component('AppToggleInput', ToggleInput)
    Vue.component('AppDatepicker', Datepicker)
    Vue.component('AppTextareaAutosize', TextareaAutosize)
    Vue.component('AppIcon', Icon)
    Vue.component('AppIconify', Iconify)
    Vue.component('AppOld5emo', Old5emo)
    Vue.component('AppGraphIcon', GraphIcon)
    Vue.component('AppMenu', Menu)
    Vue.component('AppMenuDropdown', MenuDropdown)
    Vue.component('AppMenuLocal', Local)
    Vue.component('AppMenuMobileButton', MobileButton)
    Vue.component('AppMenuSearch', Search)
    Vue.component('AppMenuSecondary', Secondary)
    Vue.component('AppPaginate', Paginate)
    Vue.component('AppTooltip', Tooltip)
    Vue.component('AppHeading', Heading)
    Vue.component('AppParagraph', Paragraph)
    Vue.component('AppTextstyle', TextStyle)
    Vue.component('AppAlert', Alert)
    Vue.component('AppModal', Modal)
    Vue.component('AppTable', Table)
    Vue.component('AppAccordion', Accordion)
  }
}
